import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import { fetchTjenesteTekster } from '@helsenorge/framework-utils/cms-tjeneste-tekster';
import { fetchResources, getResourcesFromState } from '@helsenorge/framework-utils/resources';
import { GetResourcesEvent } from './../hjelpetrigger';
import HjelpetriggerComponent from './hjelpetrigger-component';
import { getResources, Projects } from '../../resources';
import { AddHjelpetrigger, RemoveHjelpetrigger } from '../hjelpeskuff';
export class HjelpetriggerContainer extends React.Component {
    componentDidMount() {
        if (this.props.useCustomEvent) {
            const helpElement = {
                triggerComponentId: this.props.triggerComponentId, // denne skal egentlig være unik. this.createUniqueId() benyttes i container
                tjenesteNavn: this.props.tjenesteNavn,
                hjelpetekstId: this.props.hjelpetekstId,
                language: this.props.language,
            };
            const addHjelpetriggerEvent = new CustomEvent(AddHjelpetrigger, {
                detail: helpElement,
            });
            window.dispatchEvent(addHjelpetriggerEvent);
            const getResourcesEvent = new CustomEvent(GetResourcesEvent, {
                detail: helpElement,
            });
            window.dispatchEvent(getResourcesEvent);
        }
    }
    componentWillUnmount() {
        if (this.props.useCustomEvent) {
            const helpElement = {
                triggerComponentId: this.props.triggerComponentId, // denne skal egentlig være unik. this.createUniqueId() benyttes i container
            };
            const removeHjelpetriggerEvent = new CustomEvent(RemoveHjelpetrigger, {
                detail: helpElement,
            });
            window.dispatchEvent(removeHjelpetriggerEvent);
        }
    }
    render() {
        const { resources, sporsmalstekst, classes, hjelpetekstId, isDefault, size, tjenesteNavn, onClick, helpBubbleIsExpanded, stopPropagation, useCustomEvent, } = this.props;
        return (_jsx(HjelpetriggerComponent, { hjelpetekstId: hjelpetekstId, isDefault: isDefault, resources: resources, classes: classes, size: size, sporsmalstekst: sporsmalstekst, tjenesteNavn: tjenesteNavn, onClick: onClick, helpBubbleIsExpanded: helpBubbleIsExpanded, stopPropagation: stopPropagation, useCustomEvent: useCustomEvent }));
    }
}
function mapStateToProps(state, props) {
    return {
        ...props,
        resources: getResourcesFromState(state, Projects.FRAMEWORK),
    };
}
function mapDispatchToProps(dispatch, props) {
    const language = props.language ?? LanguageLocales.NORWEGIAN;
    return {
        ...props,
        mount: () => {
            dispatch(fetchResources({ project: Projects.FRAMEWORK, language: language, getResources }));
            if (props.tjenesteNavn) {
                dispatch(fetchTjenesteTekster({ name: props.tjenesteNavn, language: language }));
            }
        },
        dispatch,
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(HjelpetriggerContainer);
